import { render, staticRenderFns } from "./ProductizeUseCase.vue?vue&type=template&id=2fc001bc&scoped=true"
import script from "./ProductizeUseCase.vue?vue&type=script&lang=js"
export * from "./ProductizeUseCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc001bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc001bc')) {
      api.createRecord('2fc001bc', component.options)
    } else {
      api.reload('2fc001bc', component.options)
    }
    module.hot.accept("./ProductizeUseCase.vue?vue&type=template&id=2fc001bc&scoped=true", function () {
      api.rerender('2fc001bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/ProductizeUseCase.vue"
export default component.exports